<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  @if (loading) {
    <div class="loading-wrap">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  } @else if (response) {
    <p class="price-hint">Precio: {{ response.fuel_cost_per_km | currency }} / km</p>
    <table mat-table [dataSource]="response.trips" class="w-100">
      <ng-container matColumnDef="from_date">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let trip">{{ trip.from_date | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td mat-footer-cell *matFooterCellDef>Total</td>
      </ng-container>

      <ng-container matColumnDef="route">
        <th mat-header-cell *matHeaderCellDef>Ruta</th>
        <td mat-cell *matCellDef="let trip">{{ routeLabel(trip) }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="trip_distance_km">
        <th mat-header-cell *matHeaderCellDef>Km</th>
        <td mat-cell *matCellDef="let trip">{{ trip.trip_distance_km | number: '1.2-2' }}</td>
        <td mat-footer-cell *matFooterCellDef>{{ response.total_distance_km | number: '1.2-2' }} km</td>
      </ng-container>

      <ng-container matColumnDef="fuel_cost">
        <th mat-header-cell *matHeaderCellDef>Importe</th>
        <td mat-cell *matCellDef="let trip">{{ trip.fuel_cost | currency }}</td>
        <td mat-footer-cell *matFooterCellDef>{{ response.total_fuel_cost | currency }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayed_columns"></tr>
    </table>
  }
</mat-dialog-content>
